// Change this
const module = 'transactions'

import {checkAuth} from "@/services/auth";

// Change this
import Index from '@/views/transactions/Index'

var prefix = '/'

export default [
    {
        path: prefix+`${module}/`,
        name: `${module}Index`,
        component: Index,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
]
